
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import {
  Heading,
  ButtonPrimary,
  BaseText,
  RoundedIcon
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { ActionButtonList } from './CardButtons.types';

@Component({
  name: 'CardButtons',
  components: {
    Heading,
    ButtonPrimary,
    BaseText,
    RoundedIcon
  }
})
export default class CardButtons extends Vue {
  NebraskaColors = NebraskaColors;
  @Prop({ type: Boolean, required: false, default: false })
  ShowButtonCancel?: boolean;

  @Prop({ type: String, required: false }) title?: string;
  @Prop({ type: String, required: false }) description?: string;
  @Prop({ type: String, required: false }) paragraph?: string;
  @Prop({ type: Array, default: () => [] })
  actionButtonList!: ActionButtonList[];

  @Emit('closeEvent')
  public closeEvent() {}
}
